import React from 'react';
import '../styles/pages.css';

export default function About() {
  return (
    <div className="page-container about-page">
      <section className="about-story">
        <p>
          Annapolis Man Studios was founded by Andrew Gorbaty in 2026 to provide a platform for 
          creating his passions which he hopes he can turn into a business. While Andrew
          has had a lengthy and successful career in software engineering, he has passions outside of work like video games, board games, 
          apps, art, sports, and content creation. Trying to find a way to combine his passions with his career, Andrew decided
          to start this new venture to continue to be the change he wants to see in the world.
        </p>
        <br/>
        <p>
            For those wondering about the name "Annapolis Man", Andrew's karaoke stage name is "The Guy from Annapolis".
            One time the DJ didn't know that and called him "Annapolis Man" and the name just kinda stuck.
        </p>
        <img src="/assets/andrew_image.jpg" alt="Andrew Gorbaty" className="about-image" />
        
      </section>
    </div>
  );
}
